import React, { useEffect, useState } from "react";
import { Stepper, Step, StepLabel } from "@mui/material";
import { AccessTime } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import MakingIcon from '../../../../files/img/icons/making.png';
import ReceivingIcon from '../../../../files/img/icons/received.png';
import DeliveringIcon from '../../../../files/img/icons/delivering.png';
import { MoveRight } from "lucide-react";

const OrderStatusIndicator = ({ order, timer }) => {
    const { t } = useTranslation();
    const [timeLeft, setTimeLeft] = useState(order.will_deliver_at || 0);

    const isSystemTransfer = order.transfer_by === 'system';

    const steps = isSystemTransfer
        ? [
            { key: 'making', label: 'making', icon: <img className="image-steper" src={MakingIcon} alt="making" /> },
            { key: 'delivering', label: 'delivering', icon: <img className="image-steper" src={DeliveringIcon} alt="delivering" /> },
            { key: 'received', label: 'received', icon: <img className="image-steper" src={ReceivingIcon} alt="received" /> }
        ]
        : [
            { key: 'making', label: 'making', icon: <img className="image-steper" src={MakingIcon} alt="making" /> },
            { key: 'received', label: 'sent', icon: <img className="image-steper" src={ReceivingIcon} alt="sent" /> }
        ];

    const getStepIndex = (status) => {
        if (isSystemTransfer) {
            switch (status) {
                case "making": return 0;
                case "delivering": return 1;
                case "received": return 2;
                default: return 0;
            }
        } else {
            switch (status) {
                case "making": return 0;
                case "received": return 1; // 'received' maps to 'sent' in label
                default: return 0;
            }
        }
    };

    useEffect(() => {
        if (timeLeft <= 0) return;
        const interval = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
        return () => clearInterval(interval);
    }, [timeLeft]);

    const stepIndex = getStepIndex(order.status);

    return (
        <div className="process-stepper">
            <Stepper
                alternativeLabel
                connector={<MoveRight className="lucide-connector" />}
                activeStep={Math.floor(stepIndex)}
            >
                {steps.map((step, index) => (
                    <Step
                        key={step.key}
                        completed={index < stepIndex}
                        className={clsx(
                            "order-step",
                            index < stepIndex && "completed",
                            index === stepIndex && "current"
                        )}
                    >
                        <StepLabel icon={step.icon}>{t(step.label)}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {timer && (
                <div>
                    <AccessTime className="mr-2" />
                    {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, "0")} {t('remaining')}
                </div>
            )}
        </div>
    );
};

export default OrderStatusIndicator;
